// components/ProtectedRoute.jsx

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Loading } from './common/Loading';

const ProtectedRoute = ({
    children,
    requiredRoles = [],
    redirectTo = '/auth'
}) => {
    const { user, loading, isAuthenticated, hasRole } = useAuth();
    const location = useLocation();

    // Show loading while checking auth
    if (loading) {
        return <Loading />;
    }

    // Not authenticated - redirect to login
    if (!isAuthenticated) {
        return <Navigate to={redirectTo} state={{ from: location }} replace />;
    }

    // Check role requirements
    if (requiredRoles.length > 0 && !hasRole(requiredRoles)) {
        // User doesn't have required role - redirect to dashboard or 403 page
        return <Navigate to="/unauthorized" replace />;
    }

    // Authenticated and authorized - render children
    return children;
};

export default ProtectedRoute;